let isLogin = getStorage("isLogin", true);
let userInfo = getStorage("userInfo", true);
let permissionCodes = getStorage("permissionCodes", true);
let collapsed = getStorage("collapsed", true);
let language = getStorage("language") || "zh";
let menuList = getStorage("menuList", true);
let leftSideRoute = getStorage("leftSideRoute", true);
let projectSetting = getStorage("projectSetting") || {
	name: '',
	logo: '',
  bgImgUrl: '',
};

const state = {
  isLogin, // 是否登录
  userInfo, // 用户信息
  collapsed, // 是否缩进布局
  sideRouter: [], // 导航栏
  leftSideRoute, // 左侧导航栏
  menuList, //接口返回路由数据缓存
  permissionCodes, // 路由权限唯一标识
  language, // 当前语言
  visitedViews: [], // 导航栏数据
  cachedViews: [], // 已缓存页面路由数据
  loading: false, // 页面展示loading菊花图
  projectSetting,   // 项目配置
  reneSetting: {
	  isLongTime: 0,

  }
};

const mutations = {
  setLogin(state, value) {
    state.isLogin = value;
    setStorage("isLogin", value, true);
  },
  setUserIfo(state, value) {
    state.userInfo = value;
    setStorage("userInfo", value, true);
  },
  setCollapsed(state, value) {
    state.collapsed = value;
    setStorage("collapsed", value, true);
  },
  set_router(state, value) {
    state.sideRouter = value;
  },
  set_leftMenu(state, value) {
  	  state.leftSideRoute = value;
	  setStorage("leftSideRoute", value, true);
  },
  setPermission(state, value) {
    state.permissionCodes = value;
    setStorage("permissionCodes", value, true);
  },
  set_menuList(state, value) {
    state.menuList = value;
    setStorage("menuList", value, true);
  },
  set_language(state, value) {
    state.language = value;
    setStorage("language", value);
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setCachedViews(state, value) {
    if (state.cachedViews.includes(value.path)) return;
    if (!value.meta.noCache) {
      state.visitedViews.push(value);
      state.cachedViews.push(value.path);
    }
  },
  delCachedViews(state, value) {
    const index = state.cachedViews.indexOf(value.path);
    if (index > -1) {
      state.cachedViews.splice(index, 1);
      state.visitedViews.splice(index, 1);
    }
  },
  delAllViews(state) {
    state.cachedViews = [];
    state.visitedViews = [];
  },
  setProjectSetting(state,value) {
	  state.projectSetting.name = value.title;
	  state.projectSetting.logo = value.logoUrl;
	  state.projectSetting.bgImgUrl = value.bgImgUrl;
	  setStorage("projectSetting", state.projectSetting);
  },
  reneSetting(state, value) {
	  state.reneSetting.qrCode = value.qrCode;
	  state.reneSetting.isLongTime = value.isLongTime;
	  state.reneSetting.expirationTime = value.expirationTime;
  }
};

const actions = {
  logout({ commit }) {
    commit("setLogin", false);
    commit("setUserIfo", {});
    commit("setCollapsed", false);
    commit("delAllViews", null);
	commit("set_leftMenu", []);
	window.sessionStorage.setItem('headerOpenKey', []);
	// setStorage('headerOpenKey', [], true);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

function setStorage(key, value, isSession) {
  let obj = {
    obj: value,
  };
  if (isSession) {
    window.sessionStorage.setItem(key, JSON.stringify(obj));
  } else {
    window.localStorage.setItem(key, JSON.stringify(obj));
  }
}

function getStorage(key, isSession) {
  if (isSession) {
    if (window.sessionStorage.getItem(key)) {
      return JSON.parse(window.sessionStorage.getItem(key)).obj;
    } else {
      return undefined;
    }
  } else {
    if (window.localStorage.getItem(key)) {
      return JSON.parse(window.localStorage.getItem(key)).obj;
    } else {
      return undefined;
    }
  }
}
